let initiated = false;
document.addEventListener(
  'DOMContentLoaded',
  () => {
    // Make sure the initiation of scripts happens only once.
    if (initiated) return;
    initiated = true;
  },
  false,
);
